import { Card, Space, Statistic,Typography } from "antd"
// import { getRecentOreders } from "../../API";
import { MdLocalHospital } from "react-icons/md";
import { IoSchoolSharp } from "react-icons/io5";
import { MdShoppingCart } from "react-icons/md";
import SideMenu from "../../components/SideMenu/Index";
import '../index.css'

function Dashboard() {
    return ( 
        <div className="abc">
            <div className="ab">
        <SideMenu/></div>
        <div className="ac">
        <Space size={12} direction='vertical'>
        <Typography.Title level={4}>Dashboard</Typography.Title>
        <Space direction="horizontal">
            <DashboardCard
             icon={<MdLocalHospital />}
              title={"Hospital"}
              value={12345} />
            <DashboardCard
             icon={<IoSchoolSharp />} 
             title={"School"}
             value={12345} />
            <DashboardCard 
            icon={<MdShoppingCart />} 
            title={"Shop"}
            value={12345} />
        </Space>
    
    </Space></div>
        </div>
    
    );

}
function DashboardCard({title,value,icon}) {
    return (

     <Card>
                <Space direction="horizontal">
                {icon}
            
        
                <Statistic title={title} value={value} />
                </Space>
            </Card>
    );
}

export default Dashboard
